import * as React from 'react';
export const usdsuiSvg = React.forwardRef(function usdsuiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DDF2FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.738 14.462a4.444 4.444 0 0 1-.026 5.47l-.051.065-.014-.082a4.077 4.077 0 0 0-.04-.212c-.3-1.343-1.274-2.495-2.876-3.428-1.083-.628-1.702-1.384-1.865-2.244-.105-.556-.027-1.114.124-1.592a3.66 3.66 0 0 1 .566-1.12l.624-.78a.27.27 0 0 1 .423 0l3.136 3.923Zm.986-.78-4.179-5.226a.197.197 0 0 0-.309 0l-4.178 5.227-.014.017a5.749 5.749 0 0 0-1.229 3.568c0 3.145 2.497 5.695 5.576 5.695 3.079 0 5.575-2.55 5.575-5.695 0-1.35-.46-2.592-1.229-3.567l-.013-.018Zm-7.666.763.373-.468.012.087c.008.068.02.137.033.206.241 1.298 1.105 2.38 2.55 3.218 1.255.732 1.986 1.572 2.196 2.494.089.384.104.763.066 1.094l-.003.02-.018.01a4.19 4.19 0 0 1-1.877.441c-2.361 0-4.276-1.955-4.276-4.367a4.41 4.41 0 0 1 .943-2.736l.001.001Z',
      fill: '#298DFF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.324 3.52c6.89 0 12.476 5.586 12.476 12.476 0 6.89-5.586 12.476-12.476 12.476a12.47 12.47 0 0 1-10.711-6.076h1.543a11.166 11.166 0 0 0 9.168 4.78c6.174 0 11.18-5.006 11.18-11.18 0-6.174-5.006-11.18-11.18-11.18-3.723 0-7.02 1.82-9.052 4.618h-1.56A12.466 12.466 0 0 1 16.324 3.52Z',
      fill: '#298DFF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.397 19.554a2.896 2.896 0 0 1-1.079-.437 2.617 2.617 0 0 1-.758-.797 2.67 2.67 0 0 1-.36-1.09h1.546c.045.396.197.707.457.934.259.22.586.33.982.33.427 0 .758-.09.991-.271.233-.182.35-.435.35-.759a.733.733 0 0 0-.136-.447 1.11 1.11 0 0 0-.408-.32 3.73 3.73 0 0 0-.73-.253L5.3 16.19c-.622-.169-1.105-.409-1.449-.72-.343-.317-.515-.755-.515-1.312 0-.363.084-.69.253-.982.175-.292.418-.531.729-.72a2.98 2.98 0 0 1 1.08-.398v-1.166h1.467v1.185c.583.11 1.05.34 1.4.69.356.35.58.791.67 1.323H7.39a1.135 1.135 0 0 0-.457-.71c-.233-.168-.528-.253-.885-.253-.24 0-.453.04-.641.117a1.037 1.037 0 0 0-.428.32.711.711 0 0 0-.146.438c0 .169.049.305.146.409.104.103.243.19.418.262.182.072.44.152.778.243l.962.263c.629.175 1.102.434 1.42.777.317.344.476.798.476 1.361 0 .39-.088.74-.263 1.05-.175.311-.427.57-.758.778a2.991 2.991 0 0 1-1.147.418v1.215H5.397v-1.225Z',
      fill: '#298DFF',
    }),
  );
});
usdsuiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usdsui = {
  category: 'brand',
  colorable: false,
  name: 'usdsui',
  svg: usdsuiSvg,
};
